module.exports = __webpack_public_path__ + "static/media/refugees_opt.78d42402.png";